/**
 * API 配置 - 从环境变量读取
 */
export const API_CONFIG = {
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://192.168.41.69:8000/api'
}

export type APIConfig = typeof API_CONFIG

export interface RuntimeConfig {
  realNameVerificationEnabled: boolean
  moderationEnabled: boolean
  moderationServiceAvailable: boolean | null
}

let runtimeConfig: RuntimeConfig = {
  realNameVerificationEnabled: true,
  moderationEnabled: false,
  moderationServiceAvailable: null
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === 'object' && !Array.isArray(value)
}

export function getRuntimeConfig(): RuntimeConfig {
  return runtimeConfig
}

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  try {
    const response = await fetch(`${API_CONFIG.baseURL}/config`)
    if (!response.ok) {
      return runtimeConfig
    }

    const data: unknown = await response.json()
    if (isRecord(data)) {
      runtimeConfig = {
        realNameVerificationEnabled: typeof data.real_name_verification_enabled === 'boolean'
          ? data.real_name_verification_enabled
          : runtimeConfig.realNameVerificationEnabled,
        moderationEnabled: typeof data.moderation_enabled === 'boolean'
          ? data.moderation_enabled
          : runtimeConfig.moderationEnabled,
        moderationServiceAvailable: typeof data.moderation_service_available === 'boolean'
          ? data.moderation_service_available
          : null
      }
    }
  } catch (error) {
    console.warn('加载运行时配置失败，将使用默认配置:', error)
  }

  return runtimeConfig
}

export function setModerationServiceAvailability(available: boolean | null): RuntimeConfig {
  runtimeConfig = {
    ...runtimeConfig,
    moderationServiceAvailable: available
  }
  return runtimeConfig
}

/**
 * 验证 API 配置是否有效
 */
export function validateAPIConfig(): boolean {
  if (!API_CONFIG.baseURL) {
    console.error('API_CONFIG: baseURL 未配置')
    return false
  }
  return true
}
